/** @format */

import { createRoutingAction } from 'utils/routing';

export const GoToLegacyDashboardMigration = createRoutingAction('GO_TO_LEGACY_DASHBOARD_MIGRATION');
